const getAvailableCreditsCount = (branchC, globalC) => {
  let counter = 0;
  if (globalC) {
    const hasUnlimited = globalC.creditItems.some(c => c.availableItemsLabel === 'Ilimitado');
    if (hasUnlimited) return 'Ilimitado';
    globalC.creditItems.forEach(item => {
      counter += item.availableItems;
    });
    return counter;
  }
  if (!branchC) return 0;
  branchC.forEach(c => {
    if (c.creditItems) {
      const hasUnlimited = c.creditItems.some(cr => cr.availableItemsLabel === 'Ilimitado');
      if (hasUnlimited) {
        counter = 'Ilimitado';
      } else {
        c.creditItems.forEach(item => {
          counter += item.availableItems;
        });
      }
    }
  });
  return counter;
};

const portalId = process.env.REACT_APP_BUILD_SITE;

const helpLinkByPortal = {
  '24MX': 'https://help.inmuebles24.com/s/article/Qu%C3%A9-sucede-con-mis-planes-ya-contratados-I24',
  UBPE: 'https://help.urbania.pe/es/articles/8806179-que-sucede-con-mis-planes-ya-contratados-si-soy-profesional'
};

const getCurrentPanelHelpLink = () => {
  return helpLinkByPortal[portalId];
};

export { getAvailableCreditsCount, getCurrentPanelHelpLink };
